export const ROUTES = {
  ARTICLES: {
    NAME: "NewsArticles",
  },
  ARTICLES_BY_AUTHOR: {
    NAME: "NewsArticlesByAuthor",
  },
  ARTICLES_BY_TAG: {
    NAME: "NewsArticlesByTag",
  },
  ARTICLE: {
    NAME: "NewsArticle",
  },
  LINK_SEGMENT: "news",
} as const;
